import { Request,BaseApiUrl } from "./api";

// 列表
export const getMaterialClassListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/MaterialClass/get`, { params: params });
};


//新增
export const addMaterialClass = (params) => {
  return Request.post(`${BaseApiUrl}/api/MaterialClass/Post`, params);
};
//编辑
export const editMaterialClass = (params) => {
  return Request.post(`${BaseApiUrl}/api/MaterialClass/Put`, params);
};

//新增
export const batchDeleteMaterialClass = (params) => {
  return Request.post(`${BaseApiUrl}/api/MaterialClass/BatchDelete`, params);
};

// //批量删除
// export const batchDeleteMaterialClass = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/MaterialClass/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
